import { render, staticRenderFns } from "./ResearchOutputsSearch.vue?vue&type=template&id=69818678&scoped=true&"
import script from "./ResearchOutputsSearch.vue?vue&type=script&lang=js&"
export * from "./ResearchOutputsSearch.vue?vue&type=script&lang=js&"
import style0 from "./ResearchOutputsSearch.vue?vue&type=style&index=0&id=69818678&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69818678",
  null
  
)

export default component.exports